import React from 'react';
import './visionmission.css'; // Linked CSS file

const data = [
    {
        icon: 'fa-bullseye',
        title: 'Mission',
        text: 'To provide end-to-end construction and real estate services that combine innovation, quality, and legal assurance, ensuring every project adds lasting value.',
    },
    {
        icon: 'fa-eye',
        title: 'Vision',
        text: 'To shape modern living and business spaces by delivering sustainable developments and becoming the most trusted name in the real estate and construction sector.',
    },
    {
        icon: 'fa-star',
        title: 'Our Values',
        text: 'We believe in integrity, teamwork, and customer-first service, guided by transparency, professionalism, and a passion for timely, result-driven execution.',
    },
];

const MissionVisionValues = () => {
    return (
        <div className='container'>
            <div className="section-title clearfix d-flex flex-column align-items-center">
                <div class="title-header">
                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Vision mission & values</h5>
                    {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
                </div>
                <div className='underline'></div>
                {/* <p>Our directors bring strong leadership, deep industry knowledge, and practical project experience that guide our company’s growth and reputation.</p> */}
            </div>

            <div className="mv-section">
                {data.map((item, index) => (
                    <div className="mv-card" key={index}>
                        <div className="mv-icon-wrapper">
                            <i className={`fa ${item.icon} mv-icon`}></i>
                        </div>
                        <h3 className="mv-heading">{item.title}</h3>
                        <p className="mv-text">{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MissionVisionValues;
